exports.ByName = {
  NotInRange: { Id: 0, Name: 'NotInRange', Value: 'in_range_status.not_in_range' },
  InRange: { Id: 1, Name: 'InRange', Value: 'in_range_status.in_range' }
};

exports.ById = {
  0: { Id: 0, Name: 'NotInRange', Value: 'in_range_status.not_in_range' },
  1: { Id: 1, Name: 'InRange', Value: 'in_range_status.in_range' }
};
